if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.buyNowButton = this.querySelector('[data-okodoko-buy-now]');

        if (this.buyNowButton) this.buyNowButton.addEventListener('click', this.onBuyNowHandler.bind(this));

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.addToCart(this.submitButton);
      }

      onBuyNowHandler(evt) {
        evt.preventDefault();
        this.addToCart(this.buyNowButton, true);
      }

      addToCart(activeButton, redirectToCheckout = false) {
        if (!activeButton || activeButton.getAttribute('aria-disabled') === 'true' || activeButton.disabled) return;

        this.handleErrorMessage();
        this.error = false;

        this.setLoading(activeButton, true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.append('sections', 'cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) quickAddModal.hide(true);

            this.updateCartIcon(response);

            if (redirectToCheckout) {
              window.location = this.getCheckoutUrl();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.setLoading(activeButton, false);
          });
      }

      setLoading(activeButton, isLoading) {
        [this.submitButton, this.buyNowButton].filter(Boolean).forEach((button) => {
          if (isLoading) {
            button.setAttribute('aria-disabled', true);
          } else if (!button.disabled) {
            button.removeAttribute('aria-disabled');
          }

          const isActive = button === activeButton && isLoading;
          button.classList.toggle('loading', isActive);

          const spinner = button.querySelector('.loading__spinner');
          if (spinner) spinner.classList.toggle('hidden', !isActive);
        });
      }

      updateCartIcon(response) {
        if (!response.sections || !response.sections['cart-icon-bubble']) return;

        const cartIcon = document.getElementById('cart-icon-bubble');
        if (!cartIcon) return;

        const html = new DOMParser().parseFromString(response.sections['cart-icon-bubble'], 'text/html');
        const section = html.querySelector('#shopify-section-cart-icon-bubble') || html.querySelector('.shopify-section');
        cartIcon.innerHTML = section ? section.innerHTML : html.body.innerHTML;
        cartIcon.classList.remove('okodoko-cart-pulse');
        void cartIcon.offsetWidth;
        cartIcon.classList.add('okodoko-cart-pulse');
        window.setTimeout(() => cartIcon.classList.remove('okodoko-cart-pulse'), 850);
      }

      getCheckoutUrl() {
        const cartUrl = window.routes?.cart_url || '/cart';
        return cartUrl.replace(/\/cart\/?$/, '/checkout');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
